export default __webpack_public_path__ + "static/FbTestimonial8-cb88ba9216b78c7d2fdc2c554ff105c2.jpeg";